import { useNavigate } from "react-router-dom";

import { Button } from "@/components";

export default function ManualButton({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <Button fill="outline" onClick={() => navigate("/register/manual")}>
      {children}
    </Button>
  );
}
